import { get, patch, post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";

const ADMIN_HEADER = { "x-role": "admin" };

export const getNotifications = (params?: Record<string, unknown>) =>
  get(ENDPOINTS.NOTIFICATIONS.LIST, params, ADMIN_HEADER);

export const markAsRead = (id: string) =>
  patch(`${ENDPOINTS.NOTIFICATIONS.READ}?ids=${id}`, {}, ADMIN_HEADER);

export const markAllAsRead = () =>
  patch(ENDPOINTS.NOTIFICATIONS.READ_ALL, {}, ADMIN_HEADER);

export const getUnreadCount = () =>
  get(ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT, {}, ADMIN_HEADER);

export const getNotificationSettings = () =>
  get(ENDPOINTS.NOTIFICATIONS.SETTINGS, {}, ADMIN_HEADER);

export const updateNotificationSetting = (
  id: string,
  payload: { email: boolean; push: boolean; sms: boolean },
) =>
  patch(
    ENDPOINTS.NOTIFICATIONS.UPDATE_SETTING,
    { preferences: [{ id, ...payload }] },
    ADMIN_HEADER,
  );

const getOS = (): "ios" | "android" | "web" => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  return "web";
};

const getBrowser = (): "chrome" | "safari" | "firefox" | "edge" | "opera" => {
  const ua = navigator.userAgent;
  if (/opr\//i.test(ua)) return "opera";
  if (/edg\//i.test(ua)) return "edge";
  if (/firefox\//i.test(ua)) return "firefox";
  if (/safari/i.test(ua) && !/chrome/i.test(ua)) return "safari";
  return "chrome";
};

const getTokenType = (): "apns" | "fcm" => {
  const ua = navigator.userAgent;
  const isSafariOrIOS =
    /iphone|ipad|ipod/i.test(ua) || (/safari/i.test(ua) && !/chrome/i.test(ua));
  return isSafariOrIOS ? "apns" : "fcm";
};

const FCM_TOKEN_KEY = "fcm_token";

export const registerFCMToken = async (fcmToken: string, force = false) => {
  if (!force && localStorage.getItem(FCM_TOKEN_KEY) === fcmToken) return null;
  const res = await post(ENDPOINTS.NOTIFICATIONS.REGISTER_FCM_TOKEN, {
    token: fcmToken,
    tokenType: getTokenType(),
    platform: getOS(),
    browser: getBrowser(),
  });
  return res;
};
